import React, { useState } from "react";
import { Link } from "react-router-dom";

function NavBar() {
  // const handleScroll = () => {

  // };

  const [show, setShow] = useState(false);
  const click = () => {
    setShow(!show);
  };
  const [active, setActive] = useState("header");

  window.addEventListener("scroll", function () {
    window.scrollY >= 10 ? setActive("header active") : setActive("header");
  });
  return (
    <>
      <header class={active} data-header>
        <div class="container">
          <div class="overlay" data-overlay></div>

          <Link to="/" class="logo">
            <h4 style={{ fontSize: "40px", color: "white" }}>Filmlane</h4>
          </Link>

          <div class="header-actions">
            <button class="search-btn">
              <ion-icon name="search-outline"></ion-icon>
            </button>

            <div class="lang-wrapper">
              <label for="language">
                <ion-icon name="globe-outline"></ion-icon>
              </label>

              <select name="language" id="language">
                <option value="en">EN</option>
                <option value="au">AU</option>
                <option value="ar">AR</option>
                <option value="tu">TU</option>
              </select>
            </div>

            <Link to="/Sign">
              <button class="btn btn-primary">Sign Up</button>
            </Link>

            <Link to="/Log">
              <button class="btn btn-primary">Sign in</button>
            </Link>
          </div>

          <button
            onClick={() => click()}
            class="menu-open-btn"
            data-menu-open-btn
          >
            <i class="fa-solid fa-bars"></i>
          </button>

          <nav class={show ? "navbar active" : "navbar"} data-navbar>
            <div class="navbar-top">
              <a href="./index.html" class="logo"></a>

              <button
                onClick={() => click()}
                class="menu-close-btn"
                data-menu-close-btn
              >
                <i class="fa-sharp fa-solid fa-xmark"></i>
              </button>
            </div>

            <ul class="navbar-list">
              <li>
                <a href="/" class="navbar-link">
                  Home
                </a>
              </li>

              <li>
                <a href="/" class="navbar-link">
                  Movie
                </a>
              </li>

              <li>
                <a href="/" class="navbar-link">
                  Tv Show
                </a>
              </li>

              <li>
                <a href="/" class="navbar-link">
                  Web Series
                </a>
              </li>

              <li>
                <a href="/" class="navbar-link">
                  Pricing
                </a>
              </li>
            </ul>

            <ul class="navbar-social-list">
              <li>
                <a href="#" class="navbar-social-link">
                  <ion-icon name="logo-twitter"></ion-icon>
                </a>
              </li>

              <li>
                <a href="#" class="navbar-social-link">
                  <ion-icon name="logo-facebook"></ion-icon>
                </a>
              </li>

              <li>
                <a href="#" class="navbar-social-link">
                  <ion-icon name="logo-pinterest"></ion-icon>
                </a>
              </li>

              <li>
                <a href="#" class="navbar-social-link">
                  <i class="fa-brands fa-linkedin"></i>
                </a>
              </li>

              <li>
                <a href="#" class="navbar-social-link">
                  <ion-icon name="logo-youtube"></ion-icon>
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </header>
    </>
  );
}

export default NavBar;
